export default {
	'deals': 'Deals',
	'deals_refresh_btn': 'Refresh Data',
	'deals_client_id': 'Client ID',
	'deals_id': 'ID',
	'deals_symbol': 'Symbol',
	'deals_amount': 'Amount',
	'deals_direction': 'Direction',
	'deals_duration': 'Duration',
	'deals_request_price': 'Request Price',
	'deals_strike_price': 'Strike Price',
	'deals_expiration_price': 'Expiration Price',
	'deals_payout': 'Payout',
	'deals_open_time': 'Open Time',
	'deals_expiry_time': 'Expiry Time',
	'deals_delay': 'Delay',
	'deals_type': 'Option Type',
	'deals_result': 'Result',
	'deals_resolution': 'State',
	'deals_group_type': 'Type',
	'deals_group_name': 'Group',
	'deals_account_id': 'Account',
}